<template>
  <div
    class="d-flex-column justify-start align-start gap-9"
    :class="[mainVariant]"
  >
    <label class="t-white medium-l font-family-2" v-if="label">{{
      label
    }}</label>
    <div
      :class="[`dropdown variant-${variant}`]"
      @click="toggleDropdown"
      v-click-outside="vcoConfig"
      :id="itemKey"
      :key="itemKey"
    >
      <div
        class="selected_item d-flex-row space-between gap-6"
        :class="[!selectedItem && 'placeholder']"
      >
        <input
          v-model="search"
          class="drop_down_search t-white"
          type="text"
          :class="[!isFocused && 'd-hide']"
          ref="dropdown_search"
          :placeholder="placeholder"
          v-if="showSearch"
          style="width: 80%"
        />

        <div class="d-flex-row justify-start flex-8 gap-10">
          <img
            v-if="img === 'platform'"
            style="height: 20px"
            :src="
              '/images/pack-options/dark/' + selected.toLowerCase() + '.webp'
            "
            alt="Game platform icon"
          />
          <img
            v-if="img === 'legend'"
            style="height: 20px"
            :src="
              `/images/games/${currentGameSlug}/legends/` +
              selected.toLowerCase() +
              '.webp'
            "
            alt="Game platform icon"
          />
          <img
            v-if="img === 'role' && selected !== placeholder"
            style="height: 20px"
            :src="
              `/images/games/${currentGameSlug}/roles/` +
              selected.toLowerCase() +
              '.svg'
            "
            alt="Game platform icon"
          />
          <img
            v-if="img === 'achievement'"
            style="height: 20px"
            :src="
              `/images/achievements/achievement_` +
              selected.toLowerCase() +
              '.webp'
            "
            alt="Game achievment icon"
          />
          <span
            :class="[isFocused && showSearch && 'd-hide']"
            class="medium-m"
            v-html="selected"
          >
          </span>
        </div>

        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5333 5.2778L12.5333 7.07279L8 11.1025L3.46667 7.07279L3.46667 5.2778L4.53333 5.2778L4.53333 6.59379L8 9.67531L11.4667 6.59379L11.4667 5.2778L12.5333 5.2778Z"
            fill="white"
          />
        </svg>
      </div>

      <Transition name="slide-fade-top" v-if="showArrayDropdown">
        <div class="dropdown_list_container" v-if="isOpen">
          <div
            :class="[selected === dropItem ? 'active_item' : '', 'item']"
            v-for="dropItem in arrayItems"
            :key="dropItem"
            @click.stop="
              selectDropItem(itemKey, dropItem, game);
              closeOutside();
            "
          >
            <img
              v-if="img === 'platform'"
              style="height: 20px"
              :src="
                '/images/pack-options/dark/' +
                dropItem.toLowerCase().replace(' ', '-') +
                '.webp'
              "
              alt="Game platform icon"
            />

            <img
              v-if="img === 'achievement'"
              style="height: 20px"
              :src="
                `/images/achievements/achievement_` +
                selected.toLowerCase() +
                '.webp'
              "
              alt="Game achievment icon"
            />
            <img
              v-if="img === 'legend'"
              style="height: 20px"
              :src="
                `/images/games/${currentGameSlug}/legends/` +
                dropItem.toLowerCase() +
                '.webp'
              "
              alt="Game platform icon"
            />
            <p v-html="dropItem"></p>
          </div>
        </div>
      </Transition>

      <Transition name="slide-fade-top" v-else-if="showObjectDropdown">
        <div class="dropdown_list_container" v-if="isOpen" key="object">
          <div
            :class="[selected === dropItem ? 'active_item' : '', 'item']"
            class="d-flex-row justify-start"
            v-for="(dropItem, key) in filteredItems"
            :key="dropItem"
            @click.stop="
              selectDropItem(itemKey, key, game);
              closeOutside();
            "
          >
            <img
              v-if="img === 'platform'"
              style="height: 20px"
              :src="
                '/images/pack-options/dark/' +
                dropItem.toLowerCase().replace(' ', '-') +
                '.webp'
              "
              alt="Game platform icon"
            />
            <img
              v-if="img === 'role'"
              style="height: 20px"
              :src="
                `/images/games/${currentGameSlug}/roles/` +
                dropItem.toLowerCase() +
                '.svg'
              "
              alt="Game platform icon"
            />
            <img
              v-if="img === 'achievement'"
              style="height: 20px"
              :src="
                `/images/achievements/achievement_` +
                dropItem.toLowerCase() +
                '.webp'
              "
              alt="Game achievment icon"
            />
            <img
              v-if="img === 'legend'"
              style="height: 20px"
              :src="
                `/images/games/${currentGameSlug}/legends/` +
                dropItem.toLowerCase() +
                '.webp'
              "
              alt="Game platform icon"
            />
            <p v-html="dropItem"></p>
          </div>
        </div>
      </Transition>
    </div>
    <p class="form-error" v-if="error">* {{ error }}</p>
  </div>
</template>

<script>
import { eventBus } from "~/lib/eventBus";
export default {
  props: {
    dropItems: {
      default: [],
    },
    placeholder: {
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
    mainVariant: {
      type: String,
      default: "",
    },
    selectedItem: {
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    itemKey: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    selectDropItem: {
      type: Function,
      default: () => {},
    },
    label: {
      type: String,
      default: "",
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    game: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
      default: "",
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      search: "",
      isFocused: false,
      vcoConfig: {
        handler: this.closeOutside,
        events: ["click"],
      },
    };
  },
  components: {},

  methods: {
    toggleDropdown(e) {
      console.log(this.disabled);
      if (this.disabled) {
        return;
      }
      if (!this.isOpen) {
        this.isOpen = true;
        this.isFocused = true;
        if (this.showSearch) {
          this.$refs.dropdown_search.focus();
        }
      } else if (!this.showSearch) {
        this.isOpen = false;
        this.isFocused = false;
        this.search = "";
      }
    },
    closeOutside(e) {
      if (this.isOpen) {
        this.isOpen = false;
        this.isFocused = false;
        this.search = "";
      }
    },
  },
  computed: {
    filteredItems() {
      if (this.showObjectDropdown) {
        return Object.keys(this.objectItems)
          .filter((key) =>
            this.objectItems[key]
              ?.toLowerCase()
              .includes(this.search.toLowerCase())
          )
          .reduce((cur, key) => {
            return Object.assign(cur, {
              [key]: this.objectItems[key],
            });
          }, {});
      } else {
        return this.arrayItems.filter((item) =>
          item.title.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    },
    arrayItems() {
      if (Array.isArray(this.dropItems)) {
        if (this.selectedItem) {
          return [
            this.dropItems.find((item) => item === this.selectedItem),
            ...this.dropItems.filter((item) => item !== this.selectedItem),
          ];
        }
        return this.dropItems;
      }
      return [];
    },
    objectItems() {
      if (!Array.isArray(this.dropItems)) {
        if (this.selectedItem) {
          let itemsObject = {};

          for (const [key, value] of Object.entries(this.dropItems)) {
            if (key === this.selectedItem) {
              itemsObject = { [key]: value, ...itemsObject };
            } else {
              itemsObject = { ...itemsObject, [key]: value };
            }
          }

          return itemsObject;
        }
        return this.dropItems;
      }
      return {};
    },
    selected() {
      if (Array.isArray(this.dropItems)) {
        return this.selectedItem || this.placeholder;
      } else {
        return this.dropItems[this.selectedItem] || this.placeholder;
      }
    },

    showArrayDropdown() {
      return this.arrayItems.length > 0;
    },

    showObjectDropdown() {
      return Object.keys(this.objectItems).length > 0;
    },
  },
  setup() {
    const { currentGameSlug } = useGameComposable();
    return {
      currentGameSlug,
    };
  },
  mounted() {
    eventBus.on("closeAll", this.closeOutside); // Register the close event
  },
  beforeUnmount() {
    eventBus.off("closeAll", this.closeOutside);
  },
};
</script>
